import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { ROOT, WARRANTEE_LIST } from "./config/warranty.route";
import { MainPage, WarranteeListPage } from "./pages";

export default function WarrantyModule() {
  return (
    <Switch>
      <Route exact path={ROOT} component={MainPage} />
      <Route exact path={WARRANTEE_LIST} component={WarranteeListPage} />
      <Route path="*">
        <Redirect to="/admin/invalid" />
      </Route>
    </Switch>
  );
}

export { ROOT };
